mobileSize = 1000;
function countdown() {
    if ($('body').hasClass('saffireMobileSize')) {
        $('#siteInfoBannerWidget').insertAfter('.swiper-main');
    } else {
        $('#siteInfoBannerWidget').prependTo('.header-top .container');
    }
}


$(document).ready(function () {

    $('.cookie-banner-content p').html(`We use cookies to offer you a better browsing experience, analyze site traffic, personalize content and serve targeted advertisements. To learn more or change your cookie preferences, choose <em>Manage Cookie Preferences</em>. For further information on the use of cookies and information we collect, visit our <a href="https://www.asmglobal.com/p/other/privacy-policy" target="_blank">Privacy Policy</a>.`);

    // Check Window Size
    const windowSize = $(window).width();
    if (windowSize < 1000) {
        $('body')
            .addClass('saffireMobileSize')
            .removeClass('saffireLargeSize');
    } if (windowSize > 1000) {
        $('body').removeClass('saffireMobileSize');
    }
    $('.footer .saffire_logo').attr('src', FULLCLIENTTHEMEPATH + '/images/saffire-logo.png');
    // General Message
    $('.generalmessage').prependTo('header');
    countdown();
});

$(window).load(function () {
    countdown();
    $(".footerItems1 a").removeClass("button");
    // Weather Bug
    setInterval(function () {
        var str = $('#weatherBugDescription').text();
        var weatherBugSet = $('#weatherBugWidget').hasClass('weatherBugSet');
        if (!weatherBugSet && str != '') {
            $('#weatherBugWidget').addClass('weatherBugSet');
            var findSpace = str.lastIndexOf(' ');
            var stringLength = str.length;
            var res = str.substring(findSpace, stringLength);
            var start = str.substring(0, findSpace);
            $('#weatherBugDescription').html('<span class="weatherDescriptive">' + start + '</span>' + res);
            $('#weatherBugWidget').css('visibility', 'visible');
        }
    }, 12); $(".arrow-down").on('click', function () {
        $('html, body').animate({
            'scrollTop': $(".outer-medium").position().top
        });
    });
});
$(window).resize(function () {
    countdown();
});